import React from 'react';
import { EventTask, useProjectTasksService, TaskPermission } from 'nekst-api';
import { AfterSubmitFunc } from 'ui-builder';
import BaseEventTaskForm from './BaseEventTaskForm';
import { UpdateEventTaskButtons } from '../UpdateTaskButtons';


export interface UpdateEventTaskFormProps {
  data: EventTask;
  afterSubmitFunc?: AfterSubmitFunc;
}

export default function UpdateEventTaskForm(props: UpdateEventTaskFormProps) {
  const projectTasksService = useProjectTasksService();

  return (
    <BaseEventTaskForm
      afterSubmitFunc={props.afterSubmitFunc}
      submitFormFunc={async (formData) => {
        const result = await projectTasksService.updateTask(props.data.id, formData);
        return result as EventTask;
      }}
      data={props.data}
      initialData={props.data}
      title="Update Appointment Task"
      buttons={<UpdateEventTaskButtons />}
      isDisabled={(data) => !data.permissions?.includes(TaskPermission.UPDATE)}
    />
  );
}
